"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFocusOnMount = exports.useFocusManagement = exports.useExplicitSelectionState = void 0;
var _react = require("react");
require("focus-options-polyfill");
var _compoundComponents = require("@clds/compound-components");
// polyfill for preventScroll on Safari

const useFocusOnMount = ref => ref === null || ref === void 0 ? void 0 : ref.focus({
  preventScroll: true
});
exports.useFocusOnMount = useFocusOnMount;
const useFocusManagement = (menuRef, buttonRef, opened, focusOnClose) => {
  const firstRender = (0, _react.useRef)(true);
  (0, _react.useLayoutEffect)(() => {
    if (opened) {
      var _menuRef$current;
      (_menuRef$current = menuRef.current) === null || _menuRef$current === void 0 ? void 0 : _menuRef$current.focus();
    } else {
      if (!firstRender.current && focusOnClose) {
        var _buttonRef$current;
        (_buttonRef$current = buttonRef.current) === null || _buttonRef$current === void 0 ? void 0 : _buttonRef$current.focus();
      }
    }
    firstRender.current = false;
  }, [buttonRef, menuRef, opened, focusOnClose]);
};
exports.useFocusManagement = useFocusManagement;
const noop = () => void 0;

/** We want to make sure that selection feature is turned off by default
 * We should enable it (controlled or uncontrolled) only if appropriate control props are passed
 * */
const useExplicitSelectionState = ({
  selectedId,
  defaultSelectedId,
  onSelect
}) => {
  const supportDropdownMenuSelection = defaultSelectedId !== undefined || selectedId !== undefined;
  if (supportDropdownMenuSelection) {
    // for DropdownMenu we have to pass defaultSelectedId or selectedId to make selection even working
    return {
      defaultSelectedId,
      selectedId,
      onSelect
    };
  }
  // otherwise we disable selection feature at all - not every dropdown requires a selected option
  return {
    defaultSelectedId: undefined,
    selectedId: _compoundComponents.unselect,
    onSelect: onSelect || noop
  };
};
exports.useExplicitSelectionState = useExplicitSelectionState;
//# sourceMappingURL=DropdownMenu.hooks.js.map